export const firstCharUpper = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const capitalize = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
